/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Chaitanya
*/

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import SociollaText from '@components/sociolla/SociollaText';
import ModalImage from '@components/modal/ModalImage';
import { Spacer, ButtonSticky } from '@components/screen/Layout';
import Colors from '@global/colors';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import { isAndroid } from '@global/screens';
import { logEvent } from '@global/analytics';
import GwpTrackerAccordionItem from './gwp-tracker/GwpTrackerAccordionItem';

const MAX_ITEMS = 10;

const createLocalId = () =>
  `gwp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const createEmptyItem = () => ({
  _localId: createLocalId(),
  brand: {},
  product: {},
  campaign: '',
  campaign_detail: '',
  gwp_stock: '',
  gwp_out: '',
  images: [],
});

const normalizeItem = (raw = {}) => ({
  _localId: createLocalId(),
  brand: raw?.brand || {},
  product: raw?.product || {},
  campaign: raw?.campaign || '',
  campaign_detail: raw?.campaign_detail || '',
  gwp_stock:
    raw?.gwp_stock === undefined || raw?.gwp_stock === null
      ? ''
      : String(raw.gwp_stock),
  gwp_out:
    raw?.gwp_out === undefined || raw?.gwp_out === null
      ? ''
      : String(raw.gwp_out),
  images: Array.isArray(raw?.images) ? raw.images.filter(Boolean) : [],
});

const isItemFilled = (item = {}) =>
  Boolean(
    item?.images?.length ||
      item?.campaign ||
      item?.campaign_detail ||
      item?.gwp_stock ||
      item?.gwp_out ||
      (item?.brand?.id && item?.product?.id),
  );

const isItemStarted = (item = {}) => Boolean(item?.brand?.id);

const isItemComplete = (item = {}) =>
  Boolean(
    item?.brand?.id &&
      item?.product?.id &&
      item?.campaign &&
      item?.campaign_detail &&
      item?.gwp_stock !== '' &&
      item?.gwp_out !== '',
  );

const serializeItem = (item = {}) => ({
  type: 'gwp_tracker',
  brand: { id: item?.brand?.id, name: item?.brand?.name },
  product: {
    id: item?.product?.id,
    combination_id: item?.product?.combination_id,
    name: item?.product?.name,
    variant: item?.product?.variant,
    reference: item?.product?.reference,
    image: item?.product?.image,
  },
  campaign: item?.campaign || '',
  campaign_detail: item?.campaign_detail || '',
  gwp_stock: item?.gwp_stock || '',
  gwp_out: item?.gwp_out || '',
  images: item?.images?.length ? item.images : [],
});

const buildPayload = (items = []) => ({
  more_info: {
    campaign: items
      .filter((item) => isItemFilled(item))
      .map((item) => serializeItem(item)),
  },
});

const TodoGwpTracker = ({
  containerHeight = 0,
  detailData = {},
  detailTodo = {},
  localPayload = null,
  onSubmit = () => {},
  onSaveDraft = () => {},
  resetTab = () => {},
}) => {
  const dispatch = useDispatch();
  const isLoadingGlobal = useSelector((state) => state.modal.isLoading);
  const [items, setItems] = useState([createEmptyItem()]);
  const [expandedIds, setExpandedIds] = useState([]);
  const [uploadingMap, setUploadingMap] = useState({});
  const userEditedRef = React.useRef(false);
  const hydratedSignatureRef = React.useRef('');
  const currentTaskIdRef = React.useRef(detailTodo?._id || '');

  const updateItem = useCallback((id, patch = {}) => {
    userEditedRef.current = true;
    setItems((prev) =>
      prev.map((item) => (item._localId === id ? { ...item, ...patch } : item)),
    );
  }, []);

  const removeItem = useCallback((id) => {
    userEditedRef.current = true;
    setItems((prev) => {
      const next = prev.filter((item) => item._localId !== id);
      return next.length ? next : [createEmptyItem()];
    });
    setExpandedIds((prev) => prev.filter((itemId) => itemId !== id));
    setUploadingMap((prev) => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
  }, []);

  const addItem = useCallback(() => {
    userEditedRef.current = true;
    setItems((prev) => {
      if (prev.length >= MAX_ITEMS) {
        return prev;
      }
      const next = [...prev, createEmptyItem()];
      const newId = next[next.length - 1]._localId;
      setExpandedIds([newId]);
      return next;
    });
  }, []);

  const toggleItem = useCallback((id) => {
    setExpandedIds((prev) =>
      prev.includes(id)
        ? prev.filter((itemId) => itemId !== id)
        : [...prev, id],
    );
  }, []);

  const addImageToItem = useCallback((id, uploaded) => {
    const uri = uploaded?.uri || uploaded?.url || '';
    if (!uri) {
      return;
    }
    const imageEntry = uri.startsWith('http')
      ? { url: uri, uri }
      : {
          url: uri,
          uri,
          _localFile: {
            uri,
            filename: uploaded?.filename,
            type: uploaded?.type,
            mimeType: uploaded?.mimeType,
          },
        };
    userEditedRef.current = true;
    setItems((prev) =>
      prev.map((item) =>
        item._localId === id
          ? { ...item, images: (item.images || []).concat([imageEntry]) }
          : item,
      ),
    );
  }, []);

  const removeImageFromItem = useCallback((id, imageIndex) => {
    userEditedRef.current = true;
    setItems((prev) =>
      prev.map((item) => {
        if (item._localId !== id) {
          return item;
        }
        const nextImages = [...(item.images || [])];
        nextImages.splice(imageIndex, 1);
        return { ...item, images: nextImages };
      }),
    );
  }, []);

  const setUploadingFor = useCallback((id, loading) => {
    setUploadingMap((prev) => {
      if (loading) {
        return { ...prev, [id]: true };
      }
      const next = { ...prev };
      delete next[id];
      return next;
    });
  }, []);

  const isReady = useMemo(
    () => Object.keys(uploadingMap).length === 0,
    [uploadingMap],
  );

  const incompleteStartedItems = useMemo(
    () =>
      items
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => isItemStarted(item) && !isItemComplete(item)),
    [items],
  );

  const canSubmit = useMemo(
    () => incompleteStartedItems.length === 0 && isReady && !isLoadingGlobal,
    [incompleteStartedItems, isReady, isLoadingGlobal],
  );

  const onSubmitTodo = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      if (incompleteStartedItems.length > 0) {
        const itemLabels = incompleteStartedItems
          .map(({ index }) => `#${index + 1}`)
          .join(', ');
        dispatch(showPopup({ name: 'isLoading', value: false }));
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Incomplete GWP Tracker',
            description: `Please complete all fields for GWP Tracker item(s): ${itemLabels}.`,
            isConfirm: false,
            testID: 'todo-gwp-tracker-validation',
          }),
        );
        return;
      }

      const payload = buildPayload(items);

      logEvent({
        eventName: 'submit_activity',
        data: {
          activity_id: detailData?._id,
          task_id: detailTodo?._id,
          type: 'gwp_tracker',
          payload: JSON.stringify(payload),
        },
        dataKey: 'detail',
      });

      await onSubmit({
        targetType: 'gwp_tracker',
        taskId: detailTodo?._id,
        payload,
      });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      resetTab();
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      let error_message = 'A system error occurred';
      if (error?.response?.data?.message) {
        error_message = error.response.data.message;
      }
      if (!detailTodo?._id) {
        error_message = 'This activity have no todo list activity.';
      }
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: error_message,
          isConfirm: false,
          testID: 'todo-gwp-tracker-error',
        }),
      );
    }
  };

  useEffect(() => {
    const taskId = detailTodo?._id || '';
    if (currentTaskIdRef.current !== taskId) {
      currentTaskIdRef.current = taskId;
      userEditedRef.current = false;
      hydratedSignatureRef.current = '';
      setUploadingMap({});
      setExpandedIds([]);
    }

    if (userEditedRef.current) {
      return;
    }

    const localCampaign =
      localPayload?.more_info?.campaign || localPayload?.campaign || [];
    const source = localCampaign?.length
      ? localCampaign
      : detailTodo?.more_info?.campaign || [];

    const signature = JSON.stringify(
      source.map((item) => ({
        brand: item?.brand?.id || '',
        product: item?.product?.id || '',
        campaign: item?.campaign || '',
        campaign_detail: item?.campaign_detail || '',
        gwp_stock: item?.gwp_stock || '',
        gwp_out: item?.gwp_out || '',
        images: item?.images || [],
      })),
    );

    if (signature === hydratedSignatureRef.current) {
      return;
    }

    hydratedSignatureRef.current = signature;
    if (source.length) {
      const normalized = source.map((item) => normalizeItem(item));
      setItems(normalized);
      setExpandedIds([normalized[0]._localId]);
    } else {
      const initial = createEmptyItem();
      setItems([initial]);
      setExpandedIds([initial._localId]);
    }
  }, [detailTodo?._id, detailTodo?.more_info?.campaign, localPayload]);

  const saveDraftRef = React.useRef(onSaveDraft);

  useEffect(() => {
    saveDraftRef.current = onSaveDraft;
  }, [onSaveDraft]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const payload = buildPayload(items);
      saveDraftRef.current({
        targetType: 'gwp_tracker',
        taskId: detailTodo?._id,
        payload,
      });
    }, 500);
    return () => clearTimeout(timer);
  }, [items, detailTodo?._id]);

  return (
    <View testID="todo-gwp-tracker-container" style={styles.pageContainer}>
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={styles.content}
        showsVerticalScrollIndicator={false}>
        <View style={styles.introCard}>
          <SociollaText type="bold" style={styles.introTitle}>
            GWP Tracker
          </SociollaText>
          <SociollaText style={styles.introText}>
            Expand a card to edit details, then collapse it to keep this page
            concise.
          </SociollaText>
          <View style={styles.metaRow}>
            <View style={styles.metaPill}>
              <SociollaText style={styles.metaText}>
                {items.length}/{MAX_ITEMS} data
              </SociollaText>
            </View>
          </View>
        </View>

        {items.map((item, index) => (
          <GwpTrackerAccordionItem
            key={item._localId}
            item={item}
            index={index}
            isExpanded={expandedIds.includes(item._localId)}
            canRemove={items.length > 1}
            detailData={detailData}
            detailTodo={detailTodo}
            loading={Boolean(uploadingMap[item._localId])}
            onToggle={() => toggleItem(item._localId)}
            onRemove={() => removeItem(item._localId)}
            onUploading={(loading) => setUploadingFor(item._localId, loading)}
            onChange={(patch) => updateItem(item._localId, patch)}
            onAddImage={(uploaded) => addImageToItem(item._localId, uploaded)}
            onRemoveImage={(imgIdx) =>
              removeImageFromItem(item._localId, imgIdx)
            }
          />
        ))}

        {items.length < MAX_ITEMS ? (
          <TouchableOpacity
            testID="todo-gwp-tracker-add-btn"
            activeOpacity={0.7}
            style={styles.addButton}
            onPress={addItem}>
            <SociollaText type="bold" style={styles.addButtonText}>
              + Add GWP Tracker
            </SociollaText>
          </TouchableOpacity>
        ) : null}
      </ScrollView>

      {!isAndroid ? <Spacer /> : null}
      <ModalImage />
      <ButtonSticky
        show
        customHost="modal-sticky-button"
        buttons={[
          {
            title: !isReady ? 'Uploading...' : 'Submit GWP Tracker',
            disabled: !canSubmit,
            onPress: onSubmitTodo,
          },
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    backgroundColor: Colors.grey16,
    flex: 1,
  },
  scroll: {
    width: '100%',
  },
  content: {
    paddingHorizontal: 15,
    paddingTop: 12,
    paddingBottom: 160,
  },
  introCard: {
    width: '100%',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    paddingHorizontal: 14,
    paddingVertical: 12,
    marginBottom: 12,
  },
  introTitle: {
    fontSize: 16,
    color: Colors.black,
    marginBottom: 4,
  },
  introText: {
    fontSize: 13,
    lineHeight: 20,
    color: Colors.grey2,
  },
  metaRow: {
    marginTop: 10,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  metaPill: {
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderRadius: 999,
    backgroundColor: Colors.grey16,
    paddingHorizontal: 10,
    paddingVertical: 4,
    marginRight: 8,
    marginBottom: 6,
  },
  metaText: {
    fontSize: 11,
    color: Colors.grey1,
  },
  addButton: {
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: Colors.blue0,
    borderRadius: 10,
    backgroundColor: Colors.white,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  addButtonText: {
    fontSize: 14,
    color: Colors.blue0,
  },
});

export default React.memo(TodoGwpTracker, (prev, next) => prev == next);
